import PropTypes from 'prop-types';

// Column width for 12-column grid system (used by FlexGrid)
export default PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
